import Stack from './Stack';

const Paginacion =
({
    checking,
    sorting,
    loading,
    pages,
    pagination,
    from,
    lastPage,
    to,
    total,
    handlePage,
    handleSelectPage
}) =>
{
    return (
        <nav aria-label="Page navigation example">
            <div className="row">
                <div className="col">
                <span className='pb-3 border-bottom'><small>{`${from.toLocaleString('es-CL')} - ${to.toLocaleString('es-CL')} de `}{total && total.toLocaleString('es-CL')}{total === 1 ? ' resultado' : ' resultados'}</small></span>
                </div>
                <div className="col-9">
                    <ul className="pagination justify-content-end">
                        <Stack
                            checking={checking}
                            sorting={sorting}
                            loading={loading}
                            pages={pages}
                            pagination={pagination}
                            lastPage={lastPage}
                            handlePage={handlePage}
                            handleSelectPage={handleSelectPage}
                        />
                    </ul>
                </div>
            </div>
            <div className="row" />
        </nav>
    );
}

export default Paginacion;
